export const landingPageSplashStyles = {
  header: {
    fontSize: "x-large",
    display: "inline-block",
    smallscreen: {
      fontSize: "xxx-large",
    },
  },
};
